/**
 * Splits a string into a title and description based on the first colon.
 * @param input - The input string to split.
 * @returns An object containing the title and description.
 * @example
 * splitTitleAndDescription("Title: Description") // { title: "Title", description: "Description" }
 */
export const splitTitleAndDescription = (input = '') => {
  const regex = /^(.+?):\s*(.+)$/;
  const match = input.match(regex);

  if (!match) {
    return {
      title: '',
      description: input
    };
  }

  return {
    title: match[1].trim(),
    description: match[2].trim()
  };
};
